import { useState } from "react";
import { ArrowRight, Send } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import AffiliateSignupDialog from "@/components/marketing/AffiliateSignupDialog";
import { TELEGRAM_URL } from "@/lib/socialLinks";

const CTASection = () => {
  const navigate = useNavigate();
  const [signupOpen, setSignupOpen] = useState(false);

  return (
    <section
      data-testid="cta-section"
      className="relative py-24 lg:py-28 border-t border-vts-line overflow-hidden"
    >
      <div className="absolute inset-0 vts-grid-bg opacity-50" />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black" />

      <div className="relative mx-auto max-w-5xl px-5 lg:px-8 text-center">
        <h2 className="font-heading font-bold text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter mb-6">
          Ready to trade<br />
          <span className="text-vts-silver">your first contract?</span>
        </h2>
        <p className="text-vts-silver/70 text-base font-body max-w-xl mx-auto mb-4">
          New to Deriv? Create your free account in 2 minutes. Already have one?
          Connect with an API token and start trading instantly.
        </p>
        <div data-testid="cta-free-line" className="free-badge inline-flex items-center gap-2 px-4 py-2 rounded-full border border-emerald-400/50 bg-emerald-500/15 mb-10">
          <span className="text-xs sm:text-sm text-emerald-300 font-bold tracking-wide">
            Free bots · Free signals · Free arcade — you only need a free Deriv account
          </span>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Button
            data-testid="cta-create-account-btn"
            onClick={() => setSignupOpen(true)}
            size="lg"
            className="btn-shimmer bg-vts-blue hover:bg-vts-blueHover text-white h-12 px-8 rounded-md font-semibold animate-pulse-glow"
          >
            Create your free account
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <button
            data-testid="cta-open-desk-btn"
            onClick={() => navigate("/trade?connect=1")}
            className="inline-flex items-center gap-2 text-vts-silver hover:text-white transition font-medium text-sm px-5 py-3 border border-vts-line rounded-md hover:bg-vts-surface hover:border-vts-blue"
          >
            Already have one? <span className="text-vts-blue">Open VTS Desk →</span>
          </button>
        </div>
        <div className="mt-6 text-xs text-vts-silver/50 font-mono">
          No credit card • Free demo • Real markets
        </div>

        <div className="mt-10 pt-8 border-t border-vts-line/60 flex flex-col items-center gap-3">
          <div className="text-[10px] uppercase tracking-[0.2em] text-vts-silver/40 font-mono">
            Free signals & community
          </div>
          <a
            data-testid="cta-telegram-link"
            href={TELEGRAM_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="inline-flex items-center gap-2 text-sm font-semibold text-white bg-[#229ED9] hover:bg-[#1d8ec5] px-5 py-2.5 rounded-md transition hover:scale-[1.02]"
          >
            <Send className="h-4 w-4" /> Join our Telegram channel
          </a>
          <div className="text-[10px] text-vts-silver/40 font-mono">
            Daily signals · market alerts · bot tips
          </div>
        </div>
      </div>
      <AffiliateSignupDialog open={signupOpen} onOpenChange={setSignupOpen} />
    </section>
  );
};

export default CTASection;
